export class Device {
  constructor(deviceType, deviceId, appVersion, screenSize, viewportSize, userAgent, abTestNumber) {
    this.deviceType = deviceType
    this.deviceId = deviceId
    this.appVersion = appVersion
    this.screenSize = screenSize
    this.viewportSize = viewportSize
    this.userAgent = userAgent
    this.abTestNumber = abTestNumber
  }
}



// WEBPACK FOOTER //
// ./src/api/model/StatisticsData/Device.js